module.exports = __webpack_public_path__ + "static/img/logo-gosellcoth-free.97fb389.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-gosellcoth-free.png
// module id = OsMV
// module chunks = 134